import { noop } from 'lodash';
import { useApi } from 'api/api-context';
import { showNotification } from '@mantine/notifications';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';
import panic from 'errors/panic';
import { OnNoLongerAccessible, RevisionActionRevision } from 'components/tables/data/revision/types';

/**
 * Implements the reject delegation action for revision.
 */
export default function useRejectDelegationAction() {
  const { getAction } = useApi();

  /**
   * Makes a call to the API to reject the delegation.
   */
  async function rejectDelegation({
    revision,
    onNoLongerAccessible = noop,
  }: {
    revision: RevisionActionRevision;
    onNoLongerAccessible?: OnNoLongerAccessible;
  }) {
    const revisionDelegateRejectAction = getAction('RevisionDelegateReject');

    try {
      await revisionDelegateRejectAction({ parameters: { revisionId: String(revision.revisionId) } });

      // Remove the row from the table since the user no longer has access to this revision
      onNoLongerAccessible(revision.revisionId);

      showNotification({
        title: 'Delegovanie zamietnuté',
        message:
          revision.kind === 'revision'
            ? `Delegovanie revíznej správy ${revision.revisionName} ste úspešne zamietli.`
            : `Delegovanie formulára ${revision.revisionName} ste úspešne zamietli.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { rejectDelegation };
}
